<template>
  <div class="pt-10 mt-10">
    <h2 class="primary-text">Sign in to Continue</h2>
    <v-form ref="form" v-model="valid" class="form-right-view-lable">
      <v-text-field
        v-model="input.email"
        :rules="emailRules"
        label="Email Address"
        type="text"
      />
      <v-text-field
        v-model="input.password"
        label="Password"
        :rules="passwordRules"
        :type="visible ? 'password' : 'text'"
        required
        :append-icon="visible ? 'visibility_off' : 'visibility'"
        class="subtitle-1 login-text-clr"
        @input="text = ''"
        @click:append="() => (visible = !visible)"
        @keyup.enter="signIn"
      />
      <font color="red" class="v-virtual-table">{{ text }}</font>
      <v-row class="flex-column">
        <v-col class="text-right">
          <div class="forgot-pwd">
            <router-link to="/ForgotPassword" style="text-decoration: none">
              Forgot Password?
            </router-link>
          </div>
          <!-- <v-btn text class="px-0 primary_btn" @click="forgotPassword"
          >Forgot Password?</v-btn
        > -->
        </v-col>
        <v-col>
          <v-btn
            depressed
            class="primary_btn small"
            :disabled="!valid"
            @click="signIn"
            >Sign in</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
    <!-- <form v-if="forgotLoginFrom">
      <v-row class="flex-column">
        <v-col>
          <h2 class="primary-text">Forgot Password</h2>
        </v-col>
        <v-col>
          <v-text-field label="Email Address" />
          <v-btn
            depressed
            class="primary_btn small mt-8"
            @click="toggleLoginForms"
            >Email me a recovery link</v-btn
          >
        </v-col>
      </v-row>
    </form> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { emailRules, passwordRules } from '@/support/utils/form-rules.js';
export default {
  data: () => ({
    valid: true,
    forgotLoginFrom: false,
    loginForm: true,
    username: '',
    password: '',
    text: '',
    visible: true,
    emailRules,
    passwordRules,
    input: {
      email: null,
      password: null,
      checked: 'true',
    },
    loginResponse: {},
    response: {},
    userObject: {},
  }),
  methods: {
    ...mapActions({
      userLogin: 'users/loginAction',
      getUserById: 'users/getUserById',
    }),
    toggleLoginForms() {
      this.loginForm = !this.loginForm;
      this.forgotLoginFrom = !this.forgotLoginFrom;
    },
    async signIn() {
      if (this.$refs.form.validate()) {
        this.text = '';
        this.loginResponse = await this.userLogin({
          email: this.input.email,
          password: this.input.password,
        });
        if (this.loginResponse.status === 200) {
          this.UserById({ userId: this.loginResponse.data.id });
          localStorage.setItem('token', this.loginResponse.data.token);
          this.$router.push('/license-manager');
        } else {
          this.text = this.loginResponse.data.message;
        }
      }
    },
    UserById(user) {
      this.getUserById(user)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          console.log(err);
        });
    },
    forgotPassword() {
      this.$router.push('/forgot-password');
    },
  },
};
</script>
